import {
  INTEGRATION_TYPES,
  type IntegrationDefinition,
  type IntegrationEndpointInfo,
} from '../types'

export const DEFAULT_MUNIS_ARWS_CONFIG = {}

const MUNIS_ARWS_ENDPOINTS: IntegrationEndpointInfo[] = [
  {
    name: 'Get Bank Codes',
    method: 'POST',
    description: 'Retrieves available bank/payment codes from Munis',
    toolName: 'get_bank_codes',
  },
  {
    name: 'Get Account Balance',
    method: 'POST',
    description: 'Retrieves account balance information including total due and bill details',
    toolName: 'get_account_balance',
  },
]

export const munisArwsIntegration: IntegrationDefinition = {
  id: INTEGRATION_TYPES.MUNIS_ARWS,
  title: 'Tyler Munis (ARWS)',
  defaultConnectionName: 'Munis ARWS',
  logo: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/tyler-munis-logo.png',
  icon: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/tyler-icon.png',
  cardDescription:
    'Connect to Tyler Munis ARWS to query utility billing account balances and payment information via SOAP.',
  modalDescription:
    'Connect to the Tyler Munis IVR XML Web Service (ARWS) to enable account balance lookups and bank code queries for utility billing.',
  formFields: [
    {
      name: 'host',
      label: 'Host',
      placeholder: 'e.g., your-org-munisapp.tylerhost.net',
      helperText: 'The Munis ARWS API host for your organization (without https://)',
      required: true,
      type: 'text',
    },
    {
      name: 'username',
      label: 'Username',
      placeholder: 'Enter your Munis API username',
      helperText: 'Your Munis ARWS username is stored securely and encrypted',
      required: true,
      type: 'text',
    },
    {
      name: 'password',
      label: 'Password',
      placeholder: 'Enter your Munis API password',
      helperText: 'Your Munis ARWS password is stored securely and encrypted',
      required: true,
      type: 'password',
    },
    {
      name: 'defaultCategory',
      label: 'Default Category',
      placeholder: '60',
      helperText:
        'Default category code for bill queries (e.g., 60). Users can override this per-request.',
      required: false,
      type: 'text',
    },
  ],
  apiConfig: {
    createEndpoint: '/integrations/generate-munis-arws-integration/',
    buildPayload: (formData, config, organizationId, organizationIdentityId) => {
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        organization_identity_id: organizationIdentityId,
        username: formData.username,
        password: formData.password,
        host,
        connection_name: formData.connectionName || 'Munis ARWS',
        default_category: formData.defaultCategory ? parseInt(formData.defaultCategory, 10) : 60,
        excluded_endpoints: (config.excluded_endpoints as string[]) || [],
      }
    },
    authTokenName: 'username',
    buildTestCredentials: (formData) => ({
      host: formData.host,
      username: formData.username,
      password: formData.password,
    }),
  },
  defaultConfig: { ...DEFAULT_MUNIS_ARWS_CONFIG },
  endpoints: MUNIS_ARWS_ENDPOINTS,
  hostValidation: {
    pattern: /^[a-zA-Z0-9.-]+\.tylerhost\.net/,
    example: 'your-org-munisapp.tylerhost.net',
  },
}
